/*eslint-disable */
import { makeStyles } from '@rentacenter/racstrap';

export const exportPaymentOriginModalStyles = () => {
    const useStyles = makeStyles((theme) => ({
        py1: {
            padding: '4px',
        },
        textCenter: {
            textAlign: 'center',
        },
        py4: {
            paddingTop: theme.typography.pxToRem(24),
            paddingBottom: theme.typography.pxToRem(24),
        },
        mx1: {
            marginRight: theme.typography.pxToRem(8),
            marginLeft: theme.typography.pxToRem(8),
            borderRadius: theme.typography.pxToRem(8),
            minWidth: '120px', 
            flex: '1',       
            maxWidth: '180px',
            '&:hover': {
                backgroundColor: 'inherit',
            },
            '&.Mui-disabled': {
                backgroundColor: 'transparent',
            },
        },
        buttonContainer: {
            display: 'flex',
            justifyContent: 'center',
            gap: theme.typography.pxToRem(4),
            width: '100%',
        },
        floatRight: {
            float: 'right',
        },
        ms2: {
            marginLeft: theme.typography.pxToRem(8),
        },
        notesLabel: {
            color: '#2179FE',
            padding: '10px 10px 10px 10px',
            backgroundColor: '#459efd17',
            display: 'inline-block',
            textAlign: 'left',
            marginLeft: '10px',
            marginRight: '10px',
        },
        headerSection: {
            textAlign: 'center',
            marginBottom: '24px',
        },
        headerTitle: {
            fontSize: '2rem',
            fontWeight: 'bold',
            color: '#1F2937',
            marginTop: '-15px'
        },
        infoSection: {
            display: 'flex',
            alignItems: 'center',
            // gap: '24px',
            marginBottom: '32px',
            // paddingLeft: '8px',
            paddingRight: '8px',
            marginLeft: '14px'
        },
        infoText: {
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center'
        },
        primaryText: {
            fontSize: '1.125rem',
            color: '#374151',
            marginBottom: '12px',
            textAlign: 'center',
        },
        boldText: {
            fontWeight: 'bolder'
        },
        secondaryText: {
            fontSize: '1.125rem',
            color: '#374151',
            lineHeight: '1.5',
            textAlign: 'center',
            marginTop: '16px'
        },
        promotionText: {
            textAlign: 'center',
            margin: '20px 0'
        },
        tooltipcss: {
            height: '35px',
            marginLeft: '4px',
            marginBottom: '-2px',
            positon: 'absolute',
        },
        toolTipStyle: {
            backgroundColor: '#ECF0F3',
            color: 'black',
            top: '-60px',
        },
        arrowStyle: {
            color: '#ECF0F3'
        },
    }));
    const classes = useStyles();
    return classes;
}
